import { render, staticRenderFns } from "./detailFooter.vue?vue&type=template&id=73d4b021&scoped=true&"
import script from "./detailFooter.vue?vue&type=script&lang=ts&"
export * from "./detailFooter.vue?vue&type=script&lang=ts&"
import style0 from "./detailFooter.vue?vue&type=style&index=0&id=73d4b021&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d4b021",
  null
  
)

export default component.exports